import { render, staticRenderFns } from "./SkeletonCourseInstructorCourse.vue?vue&type=template&id=522892b0&scoped=true"
import script from "./SkeletonCourseInstructorCourse.vue?vue&type=script&lang=js"
export * from "./SkeletonCourseInstructorCourse.vue?vue&type=script&lang=js"
import style0 from "./SkeletonCourseInstructorCourse.vue?vue&type=style&index=0&id=522892b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522892b0",
  null
  
)

export default component.exports